export const LIVE_ESCAPE_GET = 'LIVE_ESCAPE_GET';
export const LIVE_ESCAPE_UPDATE = 'LIVE_ESCAPE_UPDATE';
export const ON_LIVE_ESCAPE_UPDATED = 'ON_LIVE_ESCAPE_UPDATED';